module.exports = __webpack_public_path__ + "img/pay-footer-1.5dc1e2ae.jpg";